import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewContainerRef,
  ComponentRef,
  ElementRef
} from '@angular/core';

// Servicios
import { DragulaService } from 'ng2-dragula';
import { IDesignerFactoryService } from '../../../services/designer-factory-interface';

// Components
import { BaseDesignerComponent } from './base-designer-component';
import { SxCustomControl } from '../custom/custom-control-designer.component';

// Clase base de los containers
export class SxBaseContainerDesigner extends BaseDesignerComponent
  implements OnInit, OnDestroy {
  public placeHolderContainer: ViewContainerRef;

  private dropSuscription: any;

  delimiter = '::';
  changeText: boolean = false;

  constructor(
    private dragulaService: DragulaService,
    private designerFactoryService: IDesignerFactoryService,
    containerType: string,
    container: ElementRef
  ) {
    super(container, containerType);
    this.isContainer = true;

    this.dropSuscription = dragulaService.drop.subscribe((value: any) => {
      if (value.length === 6 && value[5]) {
        return;
      }

      // El elemento que se arrastro
      const element = value[1];

      // Donde se dejo caer el elemento
      const target = value[2];

      // Desde donde se arrastro el elemento
      const source = value[3];

      const handled = this.elementDropped(element, source, target);

      if (handled) {
        value.push(handled);
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    // destruyo los hijos.
    for (let i = 0; i < this.childsDesigners.length; i++) {
      const designer = this.childsDesigners[i];
      const container = this.designerContext.designers[designer.id];

      if (container) {
        container.destroy();
      }
    }

    this.childsDesigners = null;
    // me desatacho de los eventos.
    this.dropSuscription.unsubscribe();

    super.ngOnDestroy();
  }

  // Me fijo la posicion en la que quisieron insertar el nuevo control
  calculatePosition(newElement: any): number {
    let position = 0;
    const container = this.placeHolderContainer.element.nativeElement
      .parentElement;
    // Arranco de 1 porque el primer child siempre es un div vacio que se usa de placeholder para el resto de los controles.
    let designerCount = 0;
    for (let i = 1; i < container.children.length; i++) {
      const child = container.children[i];

      if (child.tagName.toLowerCase().indexOf('sx-') !== -1) {
        designerCount++;
      }

      if (child === newElement) {
        position = designerCount; // Retorno la posicion del ultimo designer encontrado.
        break;
      }
    }
    if (position < 0) {
      position = 0;
    }

    return position;
  }

  /**
   * Maneja el evento de dropped de Dragula.
   *
   * @param element El elemento que se quiere agregar
   * @param target  Desde donde viene el elemento
   * @param source  Donde se quiere agregar el elemento
   */
  elementDropped(element, source, target): boolean {
    let handled = false;

    const elementId = super.getId(element);
    const sourceId = super.getId(source); // Si el sourceId es NULL es porque se arrastro desde la toolbar controles.
    let targetId = super.getId(target);

    if (sourceId && elementId) {
      const sourceDesigner = this.designerContext.allDesigners[sourceId];
      let elementDesigner = this.designerContext.allDesigners[elementId];

      // Este es el caso del main panel que no pertenece a allDesigners
      if (elementDesigner == null && elementId === this.id) {
        elementDesigner = this;
      }

      if (sourceDesigner && elementDesigner) {
        const elementEsThis = elementDesigner === this;
        const elementParentEsThis = elementDesigner.parent === this;
        const sourceParentEsThis = sourceDesigner.parent === this;
        const elementNoEsContainerOThis =
          !elementDesigner.isContainer || elementDesigner === this;

        // Reordenamiento dentro del mismo panel
        if (
          (elementEsThis || elementParentEsThis) &&
          sourceParentEsThis &&
          elementNoEsContainerOThis
        ) {
          const childMovedIndex = this.childsDesigners.findIndex(
            child => child.id === sourceId
          );
          const childMoveOnIndex = this.childsDesigners.findIndex(
            child => child.id === elementId
          );

          this.mover(childMovedIndex, childMoveOnIndex);

          // Remuevo el elemento nativo html que agrega dracula.
          target.removeChild(element);
          handled = true;

          // Re parent
        } else {
          const sourceParentNoEsThis = !(sourceDesigner.parent === this);
          const elementEsThis = elementDesigner === this;
          const elementNoEsContainer = !elementDesigner.isContainer;
          const elementParentEsThis = elementDesigner.parent === this;

          if (
            sourceParentNoEsThis &&
            (elementEsThis || (elementNoEsContainer && elementParentEsThis))
          ) {
            const position = this.calculatePosition(element);

            // Lo remuevo de la coleccion del padre
            const oldParent = sourceDesigner.parent as SxBaseContainerDesigner;
            const parentIndex = oldParent.childsDesigners.findIndex(
              child => child === sourceDesigner
            );
            oldParent.childsDesigners.splice(parentIndex, 1);

            // Re parent visual
            const childView = sourceDesigner.componentRef.hostView;
            const childViewIndex = oldParent.placeHolderContainer.indexOf(
              childView
            );
            oldParent.placeHolderContainer.detach(childViewIndex);
            this.placeHolderContainer.insert(childView, position);

            // Removemos el elemento que genera Dragula
            $('.gu-transit').remove();

            // Re parent logico
            sourceDesigner.parent = this;
            this.childsDesigners.splice(position, 0, sourceDesigner);
            handled = true;
          }
        }
      }
    } else {
      let containerNativeElement = target;

      // Si el usuario hizo drop sobre un control existente el elementId es un child de este container.
      const childDesigner = this.childsDesigners.find(
        child => child.id === elementId
      );
      if (sourceId == null && childDesigner && !childDesigner.isContainer) {
        targetId = this.id;

        // El padre quedo mal, queda dentro de un sx-control
        containerNativeElement = this.placeHolderContainer.element.nativeElement
          .parentElement;

        containerNativeElement.insertBefore(element, target);
      }

      // Como todos contenedores se attachan al evento drop, tengo que ver si el drop corresponde a este control.
      if (this.id === targetId) {
        // Posicion donde tengo que poner el nuevo control
        const controlPosition = this.calculatePosition(element);

        // Obtengo el typo de designer
        const designerType = element.getAttribute('designer-type');

        // Creo el designer
        const control = this.createChild(designerType);

        //Obtengo el codigo de View Engine
        if (designerType === 'SxViewEngine') control.customCode = element.getAttribute('title');

        if (!control) {
          return;
        }

        // Agrego a la coleccion de dracula para que se pueda mover.
        const bag = this.dragulaService.find('designer-bag');
        bag.drake.containers.push(control.container.nativeElement);

        control.designerContext = this.designerContext;

        // Despues de crearlo lo posiciono donde lo dropeo el usuario
        control.created.subscribe(d =>
          this.mover(this.childsDesigners.length - 1, controlPosition)
        );

        // Remuevo el elemento nativo html que agrega dracula.
        containerNativeElement.removeChild(element);

        handled = true;
      }
    }

    return handled;
  }

  /**
   * Añade un control sin drag and drop.
   *
   * @param element El elemento que se quiere agregar
   * @param instance  Instancia del target (this), donde se agregará el element
   */
  addElementWithoutDragula(element, instance): boolean {
    const handleingThis = instance == undefined ? this : instance;

    // Obtengo el typo de designer
    const designerType = element.getAttribute('designer-type');
    // Creo el designer
    const control = handleingThis.createChild(designerType);
    control.designerContext = handleingThis.designerContext;

    // Agrego a la coleccion de dracula para que se pueda mover.
    const bag = handleingThis.dragulaService.find('designer-bag');
    bag.drake.containers.push(control.container.nativeElement);

    return true;
  }

  /**
   * Mueve el elemento el la posicion "from" hacia
   * la posicion "to"
   */
  mover(from: number, to: number) {
    const movidoAlMismoLugar = from === to;
    const toMenorACero = to < 0;
    const movidoFueraDeRango =
      to > this.childsDesigners.length || from > this.childsDesigners.length;
    if (movidoAlMismoLugar || toMenorACero || movidoFueraDeRango) {
      return;
    }

    const elementToAdd = this.childsDesigners[from];

    // Reordenamiento logico de designer.
    this.childsDesigners.splice(from, 1);
    this.childsDesigners.splice(to, 0, elementToAdd);

    // Reordenamiento visual.
    this.placeHolderContainer.move(elementToAdd.componentRef.hostView, to);
  }

  // Creo recursivamente todos los hijos
  loadState(jsonRoot: any) {
    if (jsonRoot == null) {
      return;
    }

    super.loadState(jsonRoot);

    for (const child of jsonRoot.childs) {
      const childDesigner = this.createChild(child.type, child.id);
      const bag = this.dragulaService.find('designer-bag');
      bag.drake.containers.push(childDesigner.container.nativeElement);
      childDesigner.controlContext = child;
    }
  }

  // Crea un hijo y lo agrega al panel
  createChild(type: string, id?: string): any {
    if (!type) {
      return null;
    }

    const splitName = type.split(this.delimiter);
    const typeName = splitName[0];
    const componentRef = this.designerFactoryService.create(
      typeName,
      this.placeHolderContainer
    );
    if (!componentRef) {
      return null;
    }

    // set component context
    const instance = componentRef.instance;
    instance.type = type;
    instance.designerContext = this.designerContext;
    
    let elementCounter = this.craftNewId(this.designerContext.allDesigners, this.id, type);
    instance.id = !id ? `${this.id}_${type}_${elementCounter}` : id;

    instance.parent = this;
    instance.componentRef = componentRef;

    if (splitName.length === 0) {
      return instance;
    }

    (instance as SxCustomControl).customCode = splitName[1];
    (instance as SxCustomControl).esTipoTabla = splitName[2] === 'TABLA';
    (instance as SxCustomControl).isTypeList = splitName[2] === 'LIST';

    return instance;
  }

  craftNewId = (designers, id, type) => {
    let elementCounter = 0;
    for (const key in designers) {
      if (designers.hasOwnProperty(key)) {
        if(key.includes(`${this.id}_${type}`) && designers[key].parent){
          elementCounter++;
        }
      }
    }
    return elementCounter + 1;
  }

  getDesignerInfo(): any {
    if (this.designerContext == null) {
      return null;
    }

    const info = super.getDesignerInfo();
    info.childs = [];
    
    for (let i = 0; i < this.childsDesigners.length; i++) {
      const childDesigner = this.childsDesigners[i];
      const childInfo = childDesigner.getDesignerInfo();

      info.childs.push(childInfo);
    }

    return info;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/base/base-container-designer-component.ts